<template>
  <div class="bg">
    <!-- 發佈成功 -->
    <!-- <div v-if="userInfo.expire_status" class="publish-success-box">
      <TopUpTip></TopUpTip>
    </div> -->
    <!-- 發佈全景內容 -->
    <div>
      <div class="title">{{ $t("moduleTitles.pcpublish") }}</div>
      <a-divider />
      <div class="chooseBtn">
        <a-button
          type="primary"
          @click="addImage"
          >{{ $t("publish.addMer") }}</a-button
        >
        <a-button
          type="primary"
          @click="addPanoramic"
          >{{ $t("publish.addPanoramic") }}</a-button
        >
        <a
          href="https://blog.qwhouse720.com/elementor-907/"
          target="_blank"
          class="teachLink"
          >出現“圖片必須是2:1的全景圖”的提示，該怎麼辦呢？</a
        >
      </div>
      <div class="drag-upload">
        <DragUploader
          uptype="sourceimg"
          ref="uploader"
          @uploadFail="uploadFail"
          @startUploadImage="startUploadImage"
          @updateImagefiles="updateImageList"
        ></DragUploader>
      </div>
      <a-form-model>
        <a-row>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workName.label')">
              <a-input
                :placeholder="$t('publish.workName.placeholder')"
                v-model="publishName"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.industry.label')">
              <a-select
                v-model="selectedIndustry"
                :placeholder="$t('publish.industry.placeholder')"
              >
                <a-select-option
                  :key="industry.id"
                  :value="industry.id"
                  v-for="industry in industryData"
                  >{{ industry.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.customerName.label')">
              <a-input
                :placeholder="$t('publish.customerName.placeholder')"
                v-model="customer_name"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.customerTel.label')">
              <a-input
                :placeholder="$t('publish.customerTel.placeholder')"
                v-model="customer_phone"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workCategory.label')">
              <a-tree-select
                :placeholder="$t('publish.workCategory.placeholder')"
                style="width: 100%"
                v-model="selectedCate"
                :replaceFields="{
                  children: 'children',
                  title: 'name',
                  key: 'id',
                  value: 'id',
                }"
                :tree-data="cateTree"
                tree-default-expand-all
              ></a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workRegion.label')">
              <HRegionSelect @regionData="getRegionData"></HRegionSelect>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.workTag.label')">
              <CTagSelect @updateTagData="updateTagData"></CTagSelect>
            </a-form-model-item>
          </a-col>
          <a-col :span="4"></a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.savePath.label')">
              <div style="width: 100%; position: relative">
                <a-input
                  :placeholder="$t('publish.savePath.placeholder')"
                  v-model="dir_name"
                  :disabled="userInfo.team_id ? true : false"
                >
                  <a-icon
                    slot="suffix"
                    style="
                      color: rgba(0, 0, 0, 0.25);
                      fontsize: 12px;
                      width: 12px;
                      height: 12px;
                    "
                    type="down"
                  />
                </a-input>
                <div
                  v-if="userInfo.team_id == 0"
                  @click="onClickDirSelect"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                  "
                ></div>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">
            <a-col :span="12">
              <a-form-model-item :label="$t('publish.isPublic')">
                <a-radio-group
                  name="radioGroup"
                  :default-value="1"
                  @change="radioChange"
                >
                  <a-radio
                    :value="1"
                    >{{ $t("publish.public") }}</a-radio
                  >
                  <a-radio
                    :value="0"
                    >{{ $t("publish.pravite") }}</a-radio
                  >
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :span="12" label="顯示浮水印">
                <a-radio-group
                  name="radioGroup"
                  :default-value="0"
                  @change="waterradioChange"
                >
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-col>
          <a-col :span="4"></a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('publish.address.label')">
              <a-input
                :placeholder="$t('publish.address.placeholder')"
                v-model="detail_address"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <a-divider />

      <a-button
        type="primary"
        :disabled="isUploading"
        @click="clickToPublish"
        >{{ $t("publish.publish") }}
      </a-button>
    </div>

    <HMaterialModal
      :visible="materialVisible"
      ref="material"
      :type="2"
      @close="materialVisible = false"
      @handleConfirm="materialConfirm"
    ></HMaterialModal>

    <HMaterialModal
      :visible="panoramicVisible"
      ref="panoramic"
      :type="1"
      @close="panoramicVisible = false"
      @handleConfirm="materialConfirm"
    ></HMaterialModal>
    <!--目錄-->
    <a-modal
      v-model="treeVisible"
      :title="$t('actionTitles.moveTo')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="confirm"
    >
      <a-directory-tree
        :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
        :load-data="onLoadData"
        :tree-data="treeData"
        :selectedKeys="selectedKeys"
        @select="onSelect"
      />
    </a-modal>
  </div>
</template>

<script>
  import HRegionSelect from "@/components/HRegionSelect";
  import HMaterialModal from "@/components/HMaterialModal";
  import DragUploader from "@/components/DragUploader";
  import CTagSelect from "@/components/Tag";
  import TopUpTip from "@/components/TopUpTip";

  import { getIndustry, publishVRImg } from "@/api/publish";
  import { getTree as getCateTree } from "@/api/cate";
  import { getTreeDir } from "@/api/work";
  import { mapGetters } from "vuex";

  export default {
    components: {
      HRegionSelect,
      HMaterialModal,
      DragUploader,
      CTagSelect,
      TopUpTip,
    },
    data() {
      return {
        vrVisible: false,
        publishName: "",
        isPuplic: 1,
        isWater: 0,
        cateData: [],
        selectedCate: undefined,
        industryData: [],
        selectedIndustry: undefined,
        tagList: [],
        selectedTags: [],
        filesList: [],
        finalRegionId: "",
        materialVisible: false,
        customer_name: "",
        customer_phone: "",
        detail_address: "",
        dir_id: 0,
        dir_name: this.$t("moduleTitles.root"),
        treeVisible: false,
        selectedKeys: [],
        selectedName: "",
        treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
        loadedKeys: [],
        isUploading: false,

        cateTree: [],
        loadingKey: "saveWork",
        isSuccess: false,
        panoramicVisible: false,
      };
    },
    created() {
      this.$store.dispatch("getUserInfo"); //更新用戶的配置
      getIndustry().then((res) => {
        this.industryData = res.data;
      });
      getCateTree().then((res) => {
        this.cateTree = res.data;
        if (this.cateTree.length > 0) {
          // 默認選擇第一個
          this.selectedCate = this.cateTree[0].id;
        }
      });
    },
    computed: {
      ...mapGetters(["userInfo"]),
    },
    methods: {
      onClickTopup() {},
      updateTagData(data) {
        this.selectedTags = data;
      },
      materialConfirm(list) {
        let materialList = list.map((item) => {
          //區分全景圖片還是全景視頻
          if (this.materialVisible) {
            item.bgImg = item.thumb_path;
            item.name = item.filename;
          } else {
            item.bgImg = item.cover;
            item.name = item.name;
          }
          return item;
        });
        let selectedList = [];
        if (this.$refs["uploader"].fileList.length) {
          materialList.forEach((item) => {
            if (
              !this.$refs["uploader"].fileList.some(
                (value) => value.id === item.id
              )
            ) {
              selectedList.push(item);
            }
          });
        } else {
          selectedList = materialList;
        }

        this.materialVisible
          ? (this.materialVisible = false)
          : (this.panoramicVisible = false);
        this.$refs["uploader"].fileList = [
          ...this.$refs["uploader"].fileList,
          ...selectedList,
        ];
        this.$refs["uploader"].returnFileList();
      },
      addImage() {
        this.materialVisible = true;
      },
      getRegionData(result) {
        this.finalRegionId = result;
      },
      selectedCompany(data) {
        console.log(data);
      },
      radioChange(e) {
        this.isPuplic = e.target.value;
      },
      waterradioChange(e) {
        this.isWater = e.target.value;
      },
      onClickDirSelect() {
        this.treeVisible = true;
      },
      confirm() {
        if (this.selectedKeys.length <= 0) {
          this.$message.warning(this.$t("message.selectPath"));
          return;
        }
        this.dir_id = this.selectedKeys[0];
        this.dir_name = this.selectedName;
        this.treeVisible = false;
      },
      onSelect(selectedKeys, info) {
        this.selectedKeys = selectedKeys;
        this.selectedName = info.node.dataRef.name;
      },
      onLoadData(treeNode) {
        return new Promise((resolve, reject) => {
          if (treeNode.dataRef.children) {
            resolve();
            return;
          }
          getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
            if (res.code && res.data.length > 0) {
              treeNode.dataRef.children = res.data;
            } else {
              treeNode.dataRef.isLeaf = true;
            }
            this.treeData = [...this.treeData];
            resolve();
          });
        });
      },
      clickToPublish() {
        // if (this.filesList.length <= 0) {
        //   this.$message.error({
        //     content: this.$t("message.noPicture"),
        //     key: this.loadingKey,
        //     duration: 1,
        //   });
        //   return;
        // }
        const { l_imgs, m_imgs, panoVideos } = this.handlefileList(
          this.filesList
        );
        let params = {
          panoVideos: panoVideos,
          imgs: l_imgs,
          mimgs: m_imgs,
          name: this.publishName,
          industry: this.selectedIndustry,
          cate: this.selectedCate,
          region: this.finalRegionId,
          pic_tags: this.selectedTags,
          is_public: this.isPuplic,
          dir_id: this.dir_id,
          dir_name: this.dir_name,
          detail_address: this.detail_address,
          customer_phone: this.customer_phone,
          customer_name: this.customer_name,
          is_water: this.isWater,
        };
        if (
          !params.imgs.length &&
          !params.mimgs.length &&
          !params.panoVideos.length
        ) {
          this.$message.error(this.$t("publish.publishNoSelectedMessage"));
          return;
        }
        if (params.name === "") {
          this.$message.error(this.$t("publish.workName.message"));
          return;
        }
        if (!params.industry) {
          this.$message.error(this.$t("publish.industry.message"));
          return;
        }
        if (params.cate === "") {
          this.$message.error(this.$t("publish.workCategory.message"));
          return;
        }
        if (params.region === "") {
          this.$message.error(this.$t("publish.workRegion.message"));
          return;
        }
        if (params.pic_tags.length === 0) {
          this.$message.error(this.$t("publish.workTag.message"));
          return;
        }
        if (params.customer_name === "") {
          this.$message.error(this.$t("publish.customerName.message"));
          return;
        }
        if (params.customer_phone === "") {
          this.$message.error(this.$t("publish.customerTel.message"));
          return;
        }
        if (params.detail_address === "") {
          this.$message.error(this.$t("publish.address.message"));
          return;
        }
        if (params.dir_id === "") {
          this.$message.error(this.$t("publish.savePath.message"));
          return;
        }
        this.$message.loading({
          content: " ",
          key: this.loadingKey,
        });
        let isError = false;
        if (!params.mimgs.length && params.panoVideos.length) {
          publishVRImg(params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success({
                  content: this.$t("publish.publishSuccess"),
                  key: this.loadingKey,
                  duration: 2,
                });
                this.jumpToPage();
              }
            })
            .catch((err) => {
              console.log("err =>", err);
              isError = true;
            });
        } else {
          publishVRImg(params)
            .then((res) => {
              console.log("res =>", res);
            })
            .catch((err) => {
              console.log("err =>", err);
              isError = true;
            });
          setTimeout(() => {
            if (isError) return;
            this.$message.success({
              content: this.$t("publish.publishSuccess"),
              key: this.loadingKey,
              duration: 2,
            });
            this.jumpToPage();
          }, 1000);
        }
      },
      jumpToPage() {
        if (this.userInfo.type == 4) {
          this.$router.push({
            path: "/employee/work/list",
          });
        } else {
          this.$router.push({
            path: "/member/work/list",
          });
        }
      },
      // 開始上傳圖片
      startUploadImage() {
        this.isUploading = true;
      },
      // 上傳失敗
      uploadFail() {
        this.isUploading = false;
      },
      // TODO新的文件上傳完畢後的處理方法
      updateImageList(fileList) {
        this.filesList = fileList;
        this.isUploading = false;
      },
      // 老的文件上傳完畢後的處理方法
      handlefileList(list) {
        console.log(list);
        let l_imgs = [];
        let m_imgs = []; //pano_id
        let panoVideos = [];
        if (list && list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (item.thumb_path) {
              m_imgs.push({
                imgsrc: item.location,
                imgname: item.filename,
                pano_id: item.id,
                thumb_path: item.thumb_path,
              });
            } else if (item.cover) {
              //全景視頻
              panoVideos.push({
                id: item.id,
                name: item.name,
                cover: item.cover,
              });
            } else {
              l_imgs.push({
                imgsrc: item.key,
                imgname: item.name,
                filesize: item.filesize,
              });
            }
          }
        }
        return { l_imgs, m_imgs, panoVideos };
      },
      addPanoramic() {
        this.panoramicVisible = true;
      },
    },
  };
</script>

<style lang="less" scoped>
  .bg {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    padding: 20px 30px;
  }

  .publish-success-box {
    height: calc(100vh - 150px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .publish-title {
    font-size: 14px;
    color: #000000;
  }

  .drag-upload {
    margin-top: 24px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.02);
  }

  .options-item {
    flex: 0 0 40%;
  }

  .tag {
    display: flex;
    justify-content: space-between;
  }

  .radio {
    margin-top: 24px;
  }

  .tag-content {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .chooseBtn .ant-btn {
    margin-right: 15px;
  }

  .specialBtn {
    background-color: #7101ad;
    border-color: #7101ad;
  }
  .chooseBtn {
    display: flex;
  }
  .teachLink {
    margin-left: auto;
  }
</style>
